import { connect } from 'react-redux';

import MapLegend from '../../lib/CanopyMapLegend';

const mapStateToProps = ({ browser, mapLayers }) => ({
  width: browser.width,
  activeLayers: mapLayers.activeLayers,
  mapDataLayers: mapLayers.dataLayers,
});

export default connect(mapStateToProps, null)(MapLegend);



// WEBPACK FOOTER //
// ./src/containers/MapLegendConnected.jsx